var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-block-list-media-custom"},[(_vm.byline)?_c('span',{domProps:{"innerHTML":_vm._s(_vm.byline)}}):_vm._e(),_vm._v(" "),(_vm.title)?_c('h2',{domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.media)?_c('Media',{attrs:{"data":_vm.media}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }